import React from 'react';

const MYOVocationalDomain = ({ color, size = 50 }: { color: string; size?: number; background?: string }) => (
  <svg viewBox="0 0 60 73" width={size / 1.1} height={size / 1.3} fill={'white'}>
    <g>
      <mask
        id="mask0_41_4906"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="73"
        height="73"
      >
        <path d="M0.359863 0.359863H72.3599V72.3599H0.359863V0.359863Z" fill="white" />
      </mask>
      <g mask="url(#mask0_41_4906)">
        <path
          d="M39.2727 49.6359H32.7273C30.9273 49.6359 29.4545 48.1632 29.4545 46.3631H6.57816V59.4541C6.57816 63.0541 9.52361 65.9995 13.1236 65.9995H58.9091C62.5091 65.9995 65.4545 63.0541 65.4545 59.4541V46.3631H42.5454C42.5454 48.1632 41.0727 49.6359 39.2727 49.6359ZM62.1818 19.0904H49.0909C49.0909 11.8577 43.2327 5.99951 36 5.99951C28.7673 5.99951 22.9091 11.8577 22.9091 19.0904H9.81816C6.21816 19.0904 3.27271 22.0359 3.27271 25.6359V35.4541C3.27271 39.0868 6.18543 41.9995 9.81816 41.9995H29.4545V38.7268C29.4545 36.9268 30.9273 35.4541 32.7273 35.4541H39.2727C41.0727 35.4541 42.5454 36.9268 42.5454 38.7268V41.9995H62.1818C65.7818 41.9995 68.7272 39.0541 68.7272 35.4541V25.6359C68.7272 22.0359 65.7818 19.0904 62.1818 19.0904ZM29.4545 19.0904C29.4545 15.4904 32.4 12.545 36 12.545C39.6 12.545 42.5454 15.4904 42.5454 19.0904H29.4218H29.4545Z"
          fill={color}
        />
      </g>
    </g>
  </svg>
);

export default MYOVocationalDomain;
